<template>
<div id="rulesFilesList">
  <button class="btn btn-primary mb-2" :disabled="loading || failedLoad" @click="$emit('add-new-rule')" id="rulesFilesList-addNewRuleButton">
    <i class="fa fa-plus" id="rulesFilesList-addNewRuleButton"></i> {{ 'ADD_RULE' | translate }}
  </button>

  <div class="position-relative" id="rulesFilesList-Loadingdiv">
    <div v-if="loading" class="files-loading" id="rulesFilesList-filesLoading">
      <custom-spinner></custom-spinner>     
    </div>
    <table class="table table-sm table-hover" id="rulesFilesList-table">
      <thead id="rulesFilesList-tableHead">
        <tr id="rulesFilesList-tableRow">
          <th id="rulesFilesList-FILES" style="width: 35%" class="font-weight-bold">{{ 'FILES' | translate }}</th>
          <th id="rulesFilesList-LAST_MODIFIED" class="font-weight-semibold small text-muted">{{ 'LAST_MODIFIED' | translate }}</th>
          <th id="rulesFilesList-CREATED" class="font-weight-semibold small text-muted">{{ 'CREATED' | translate }}</th>
          <th id="rulesFilesList-EMPTY" class="text-right"></th>
        </tr>
      </thead>
      <tbody id="rulesFilesList-tableBody">
        <tr v-for="(file, key) in rulesFiles" :key="key"
            :class="{ 'selected font-weight-semibold': rule === key }"
            @click="(rule === key) ? '' : $emit('select-file', key)" id="rulesFilesList-tableRow">
          <td class="text-truncate" :title="key">{{ key }}</td>
          <td class="small text-muted">{{ parseDate(file.lastModificationTime) }}</td>
          <td class="small text-muted">{{ parseDate(file.creationTime) }}</td>
          <td class="text-right" id="rulesFilesList-textRight-data">
            <small v-if="removing.includes(key)" class="action-icon text-danger" :id="'rulesFilesList-refresh'+ key">
              <i class="fa fa-refresh fa-spin"></i> {{ 'DELETING' | translate }}
            </small>
            <span v-else @click.stop="selectRuleForRemoval(key)" class="action-icon text-danger hover-visible" :id="'rulesFilesList-delete'+ key">
              <i class="fa fa-trash-o"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <confirm-dialog :show="showConfirmForRemoveRule"
                  :textLabel="'msg.SURE_DELETE_FILE'"
                  @hide-dialog="showConfirmForRemoveRule = false"
                  @confirm="removeRule"
                  id="rulesFilesList-confirmDialog">
  </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import ConfirmDialog from '../../dialog/ConfirmDialog';
import CustomSpinner from '../../CustomSpinner.vue';

export default {
  components: { ConfirmDialog, CustomSpinner },
  props: ['rule', 'refresh'],
  data: function () {
    return {
      rest: new RestService(),
      rulesFiles: null,
      newRuleFileName: null,
      loading: false,
      failedLoad: false,
      removing: [],
      showConfirmForRemoveRule: false,
      lastRuleForRemoval: null,
      dateLocale: 'nl-NL',
      dateOptions: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }
    }
  },
  beforeMount: function() {
    this.loadRulesList();
  },
  methods: {
    loadRulesList() {
      this.loading = true;
      this.failedLoad = false;
      this.rest.getRulesFilesList()
        .then((res) => {
          this.rulesFiles = res.data;
          this.loading = false;
        }).catch((err) => {
          this.rulesFiles = null;
          this.failedLoad = true;
          this.loading = false;
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: err.response.data
          });
        });
    },
    selectRuleForRemoval(filename) {
      this.lastRuleForRemoval = filename;
      this.showConfirmForRemoveRule = true;
    },
    removeRule() {
      let filename = this.lastRuleForRemoval;
      this.showConfirmForRemoveRule = false;
      this.removing.push(filename);
      this.rest.deleteRuleFile(filename)
        .then(() => {
          this.loadRulesList();
          this.removing.splice(this.removing.indexOf(filename), 1);
          this.$emit('remove-rule', filename);
          this.$notify({
            type: 'alert-info',
            text: '<strong>' + filename + '</strong> ' + this.$options.filters.translate('SUCCESSFULLY_REMOVED_FILE', 'msg')
          });
        }).catch((err) => {
          this.rulesFiles = null;
          this.loading = false;
          this.$notify({
            type: 'alert-danger',
            duration: -1,
            text: err.response.data
          });
        });
    },
    parseDate(timestamp) {
      if (timestamp === '') {
        return timestamp;
      } else {
        let date = new Date(timestamp);
        return new Intl.DateTimeFormat(this.dateLocale, this.dateOptions).format(date);
      }
    }
  },
  watch: {
    refresh: function(val) {
      if (val) {
        this.loadRulesList();
        this.$emit('loading-files');
      }
    }
  }
}
</script>

<style scoped>
  .files-loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 100px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }
  table {
    table-layout: fixed;
  }
  tr th, tr td {
    vertical-align: middle;
  }
  thead tr th, thead tr td {
    border-top: 0;
  }
  tbody tr {
    cursor: pointer;
  }
  tbody tr.selected {
    background-color: rgba(0, 0, 0, .05);
  }
  .action-icon {
    margin-left: 8px;
  }
  .hover-visible {
    display: none;
  }
  tbody tr:hover .hover-visible,
  tbody tr.selected .hover-visible {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/rules/RulesFilesList.vue